/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_ChooseInputs */

const en_cc_choose = /** @type {(inputs: Cc_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose…`)
};

const id_cc_choose = /** @type {(inputs: Cc_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih…`)
};

/**
* | output |
* | --- |
* | "Choose…" |
*
* @param {Cc_ChooseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_choose = /** @type {((inputs?: Cc_ChooseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_ChooseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_choose(inputs)
	return en_cc_choose(inputs)
});